import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function WhoCanJoin() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section id="teilnehmer" className="py-24 md:py-32 px-6 bg-white" data-id="element-377">
      <div className="max-w-7xl mx-auto" data-id="element-378">
        <div className="text-center mb-16" data-id="element-379">
          <span className="block text-xs font-body tracking-[0.3em] text-brand-accent uppercase mb-4" data-id="element-380">
            Wer kann teilnehmen
          </span>
          <h2 className="text-4xl md:text-5xl font-heading text-[#1a1a2e]" data-id="element-381">
            Für Models & Fotografen
          </h2>
        </div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-382">
          {/* Models Card */}
          <motion.div variants={cardVariants} className="group relative bg-[#f5f5f7] border border-[#e2e2e6] hover:border-brand-accent/40 rounded-2xl p-8 md:p-12 transition-all duration-500 hover:-translate-y-2 shadow-sm hover:shadow-md overflow-hidden" data-id="element-383">
            <div className="absolute top-0 right-0 p-8 opacity-5 transition-opacity" data-id="element-384">
              <span className="font-heading text-8xl italic text-[#1a1a2e]" data-id="element-385">
                M
              </span>
            </div>
            <h3 className="text-3xl font-heading text-[#1a1a2e] mb-6 relative z-10" data-id="element-386">
              Models
            </h3>
            <p className="text-[#4a4a5a] font-light leading-relaxed mb-8 relative z-10" data-id="element-387">
              Du möchtest dein Portfolio mit einzigartigen Bildern aus
              internationalen Locations erweitern? Bewirb dich für unsere
              nächste Reise und werde Teil eines exklusiven Kreativ-Erlebnisses.
            </p>

            <ul className="space-y-4 mb-10 relative z-10" data-id="element-388">
              {['Professionelles oder semi-professionelles Auftreten', 'Aktiver Instagram-Account', 'Passt zum visuellen Stil unserer Community'].map((req, i) => <li key={i} className="flex items-start gap-3 text-[#4a4a5a] text-sm" data-id="element-389">
                  <CheckIcon className="w-5 h-5 text-brand-accent flex-shrink-0" data-id="element-390" />
                  <span data-id="element-391">{req}</span>
                </li>)}
            </ul>

            <a href="#bewerbung" className="inline-block px-8 py-3 bg-brand-accent/85 text-white font-medium text-sm rounded-sm hover:bg-brand-accent transition-colors relative z-10" data-id="element-392">
              Jetzt bewerben
            </a>
          </motion.div>

          {/* Photographers Card */}
          <motion.div variants={cardVariants} className="group relative bg-[#f5f5f7] border border-[#e2e2e6] hover:border-brand-accent/40 rounded-2xl p-8 md:p-12 transition-all duration-500 hover:-translate-y-2 shadow-sm hover:shadow-md overflow-hidden" data-id="element-393">
            <div className="absolute top-0 right-0 p-8 opacity-5 transition-opacity" data-id="element-394">
              <span className="font-heading text-8xl italic text-[#1a1a2e]" data-id="element-395">
                F
              </span>
            </div>
            <h3 className="text-3xl font-heading text-[#1a1a2e] mb-6 relative z-10" data-id="element-396">
              Fotografen
            </h3>
            <p className="text-[#4a4a5a] font-light leading-relaxed mb-8 relative z-10" data-id="element-397">
              Als Fotograf kannst du teilnehmen, wenn du ein Model mitbringst,
              das zu unserem visuellen Konzept und Portfolio-Stil passt. So
              stellen wir sicher, dass jede Reise kreativ harmoniert.
            </p>

            <ul className="space-y-4 mb-10 relative z-10" data-id="element-398">
              {['Eigenes Portfolio mit hochwertigem Bildstil', 'Model muss zum Gesamtkonzept passen', 'Bereitschaft zur kreativen Zusammenarbeit'].map((req, i) => <li key={i} className="flex items-start gap-3 text-[#4a4a5a] text-sm" data-id="element-399">
                  <CheckIcon className="w-5 h-5 text-brand-accent flex-shrink-0" data-id="element-400" />
                  <span data-id="element-401">{req}</span>
                </li>)}
            </ul>

            <a href="#bewerbung" className="inline-block px-8 py-3 border border-brand-accent text-brand-accent font-medium text-sm rounded-sm hover:bg-brand-accent/5 transition-colors relative z-10" data-id="element-402">
              Anfrage senden
            </a>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="mt-12 text-center max-w-3xl mx-auto" data-id="element-403">
          <p className="text-xs text-[#8a8a9a] uppercase tracking-wider leading-relaxed border-t border-[#e2e2e6] pt-8" data-id="element-404">
            <span className="text-brand-accent font-medium" data-id="element-405">Hinweis:</span>{' '}
            Fotografen können nur in Begleitung eines passenden Models
            teilnehmen. Dies sichert die kreative Qualität und den visuellen
            Zusammenhalt jeder Reise.
          </p>
        </motion.div>
      </div>
    </section>;
}